import Storage from 'grab-storage';
import { STORAGE_MEX_INFO } from 'constants/app-constants';
import _get from 'lodash/get';

// if this key exist, it means that it is from mex app
// mex app will inject this key upon initialising the webview
export const isFromMexApp = () => !!Storage.getItem(STORAGE_MEX_INFO);

export const getMexInfo = () => {
  let res = {};
  try {
    res = JSON.parse(Storage.getItem(STORAGE_MEX_INFO));
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('__MEX_INFO__ fails json parse:', e);
  }
  return res;
};

export const getMexCreateDeliveryInfo = () => ({
  source: 'MEXAPP',
  additionalData: {
    mexUserID: _get(getMexInfo(), 'serviceID', '').toString(),
  },
});

export default { isFromMexApp, getMexInfo, getMexCreateDeliveryInfo };
